// extracted by mini-css-extract-plugin
export default {"tupacGrid":"om-z","tupacHeader":"pm-z","tupacHeader2":"qm-z","tupacMenu":"rm-z","tupacMenu2":"sm-z","tupacMain":"tm-z","tupacMain2":"um-z"};